import {
  classLangTypeSchema,
  classLessonTimeSchema,
  curriculumTypeSchema,
  langTypeSchema,
  lessonTimeSchema,
} from '@server/presentation'
import { z } from 'zod'

export const levelDetailQueryParamsSchema = z.object({
  langType: z.coerce.string().optional().pipe(classLangTypeSchema),
  lessonTime: z.coerce.number().int().positive().optional().pipe(classLessonTimeSchema),
  level: z.coerce.number().positive().optional(),
  curriculumType: curriculumTypeSchema.extract(['BASIC', 'TRIAL', 'SMART_TALK']),
})

export const aiCharacterChatLevelDetailQueryParamsSchema = z.object({
  langType: z.coerce.string().optional().pipe(langTypeSchema),
  lessonTime: z.coerce.number().int().positive().optional().pipe(lessonTimeSchema),
  level: z.coerce.number().positive().optional(),
  curriculumType: curriculumTypeSchema.extract(['BASIC', 'TRIAL', 'SMART_TALK']),
})
